module.exports = __webpack_public_path__ + "assets/projects/berlinfuchs/overlay-animation.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/berlinfuchs/overlay-animation.mp4
// module id = 36
// module chunks = 0